import React, { useState } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import EnTetePage from '../../Layout/EnTetePage/EnTetePage';

import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import Tableau from '../../Tableau/Tableau';

import AddCategoryModal from './AddCategoryModal/AddCategoryModal';
import { deleteCategory } from '../../../slices/itemsSlice';

const useStyles = makeStyles()(() => ({
  root: {
    margin: 'auto',
    width: '99%',
    padding: '20px',
  },
}));

export default function Categories() {
  const { classes } = useStyles();
  const { t } = useTranslation('categories');
  const categories = useSelector((state) => state.items.categories)
    .map((category) => ({ ...category }));

  const [addCategoryModalOpen, setAddCategoryModalOpen] = useState(false);
  // La catégorie en cours d'édition. `null` veut dire « on en crée une ».
  const [selectedCategory, setSelectedCategory] = useState(null);

  const dispatch = useDispatch();

  const handleAddCategoryModalClose = () => {
    setAddCategoryModalOpen(false);
    setSelectedCategory(null);
  };

  const handleAddCategoryModalOpen = () => {
    setSelectedCategory(null);
    setAddCategoryModalOpen(true);
  };

  const handleEditCategory = (category) => {
    setSelectedCategory(category);
    setAddCategoryModalOpen(true);
  };

  const handleDeleteCategory = (category) => {
    // ⚠️ La confirmation est celle que le produit posait déjà par l'édition en
    // ligne : la retirer ferait d'un clic une suppression définitive.
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (window.confirm(t('table.delete_confirmation'))) {
      dispatch(deleteCategory(category));
    }
  };

  return (
    <>
      {/* Montée à la demande : gardée en place, la fenêtre rejouerait les
          valeurs de la catégorie précédente au rendu suivant. */}
      {addCategoryModalOpen && (
        <AddCategoryModal
          display={addCategoryModalOpen}
          handleClose={handleAddCategoryModalClose}
          category={selectedCategory}
        />
      )}
      {/* <DeleteCustomerModal
       display={deleteCustomerModalOpen}
       handleClose={handleDeleteCustomerModalClose} /> */}
      <Grid container spacing={2} className={classes.root}>
        <Grid item xs={12}>
          <EnTetePage titre={t('categories')} intro={t('intro')} />
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            component="label"
            color="secondary"
            onClick={handleAddCategoryModalOpen}
          >
            {t('add_category.button')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Tableau
            colonnes={[{ title: t('name'), field: 'name' }]}
            donnees={categories}
            titre={t('categories')}
            actions={[
              {
                icon: () => <EditIcon />,
                tooltip: t('add_category.save_button'),
                onClick: (event, category) => handleEditCategory(category),
              },
              {
                icon: () => <DeleteIcon />,
                tooltip: t('table.delete_confirmation'),
                onClick: (event, category) => handleDeleteCategory(category),
              },
            ]}
          />

        </Grid>

      </Grid>
    </>
  );
}
